"use client";

import React from "react";
import { Segment } from "semantic-ui-react";

/**
 * Client-safe wrapper for Semantic UI Segment component
 * Can be used in Server Components for SSR + SEO
 */
export default function SegmentShim({ children, ...props }) {
  return <Segment {...props}>{children}</Segment>;
}
